// extracted by mini-css-extract-plugin
module.exports = {"cursor":"NotificationBadge_cursor__18O5M","root":"NotificationBadge_root__JsaD2"};